// src/features/owner/components/EmptyState.tsx — centred icon + message for empty data states.
import styled from 'styled-components';
import { Icon, type IconName } from '@/icons';

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px 12px;
  color: ${({ theme }) => theme.color.textMuted};
  text-align: center;
`;

export function EmptyState({ icon, message }: { icon: IconName; message: string }) {
  return (
    <Box>
      <Icon name={icon} size={22} />
      {message}
    </Box>
  );
}
